module.exports = __webpack_public_path__ + "img/title_anime.5b57d0da.gif";